angular.module('aprima-core-ui').directive('apHideDevice', ['DeviceSettings', function (DeviceSettings) {
    'use strict';
    //Will hide the element if running on a device

    return function(scope, element) {
        if(DeviceSettings.isDevice || DeviceSettings.isPhoneOrOverride || DeviceSettings.isTabletOrOverride){
            element.addClass('ng-hide');
        }
    };
}]);
